import { createContext } from 'react';
import type { OnboardingCatalogType } from './types';

export type CatalogsContextType = {
  onboardingCatalogs: OnboardingCatalogType;
  updateOnboardingCatalogs: (values: OnboardingCatalogType) => void;
  resetCatalogsValues: () => void;
};

const CatalogsContext = createContext<CatalogsContextType>(
  {} as CatalogsContextType,
);

export default CatalogsContext;
